import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function UserIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M2.906 20.25a10.5 10.5 0 0 1 18.187 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round" />
    </BaseIcon>
  )
}
